import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// redux
import STATUS from '../../redux/actions/constants';
import getProjects from '../../redux/actions/projectActions';

import HomeSection from './HomeSection';
import ProjectList from '../projects/ProjectList';
import ContainerLoader from '../common/ContainerLoader';
import Messenger from '../common/Messenger';

export default function ProjectSection() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getProjects());
  }, []);

  const { status, projects } = useSelector((state) => state.projects);

  return (
    <HomeSection
      title="Projects"
      subheader="GESCH's portfolio showcases our expertise in conducting high-profile Environmental Impact Assessments (EIAs), Resettlement Action Plans (RAPs), and Environmental and Social Management Plans (ESMPs) across diverse sectors throughout Africa."
      className="light-bg"
    >
      {status === STATUS.LOADING && (<ContainerLoader />)}
      {status !== STATUS.LOADING && projects && projects.length === 0 && (
        <Messenger message="Our project portfolio is being updated with our latest work. Contact us to learn about our current projects and capabilities." />
      )}
      {status !== STATUS.LOADING && projects && projects.length > 0 && (
        <ProjectList projects={projects} />
      )}
    </HomeSection>
  );
}
